import React from 'react';

const Search = () => (
  <path d="M20.743 19.3287l5.976 5.976c.9428.9428-.4715 2.357-1.4143 1.4142l-5.976-5.976C17.605 22.1536 15.4013 23 13 23 7.4772 23 3 18.5228 3 13S7.4772 3 13 3s10 4.4772 10 10c0 2.4013-.8464 4.6049-2.257 6.3287zM13 21c4.4183 0 8-3.5817 8-8s-3.5817-8-8-8-8 3.5817-8 8 3.5817 8 8 8z" />
);

export default Search;
